// @flow

import type {
  SwatchSettingsState,
  SwatchSettingsAction
} from 'stores/flow-type/swatch-settings.type';

import {
  GET_SWATCH_SETTINGS_REQUEST,
  GET_SWATCH_SETTINGS_SUCCESS,
  GET_SWATCH_SETTINGS_FAILURE,
  UPDATE_SWATCH_SETTINGS_REQUEST,
  UPDATE_SWATCH_SETTINGS_SUCCESS,
  UPDATE_SWATCH_SETTINGS_FAILURE
} from 'stores/flow-type/swatch-settings.type';

const initialState: SwatchSettingsState = {
  getLoading: false,
  updateLoading: false,
  success: false,
  error: undefined,
  swatchSettings: {},
  total: 0,
  isSearchResult: false
};

const swatchSettingsReducers = (
  state: SwatchSettingsState = initialState,
  action: SwatchSettingsAction
) => {
  switch (action.type) {
    case GET_SWATCH_SETTINGS_REQUEST:
      return { ...state, getLoading: true };
    case UPDATE_SWATCH_SETTINGS_REQUEST:
      return {
        ...state,
        updateLoading: true
      };
    case GET_SWATCH_SETTINGS_SUCCESS: {
      const { data } = action.payload;

      const { data: swatchSettings, total, isSearchResult } = data;
      return {
        ...state,
        getLoading: false,
        error: undefined,
        swatchSettings,
        total,
        isSearchResult
      };
    }
    case UPDATE_SWATCH_SETTINGS_SUCCESS: {
      const { data } = action.payload;
      const { data: swatchSettings } = data;

      return {
        ...state,
        updateLoading: false,
        error: undefined,
        swatchSettings
      };
    }
    case GET_SWATCH_SETTINGS_FAILURE:
    case UPDATE_SWATCH_SETTINGS_FAILURE:
      return {
        ...state,
        getLoading: false,
        updateLoading: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default swatchSettingsReducers;
